import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createBlock as _createBlock, isRef as _isRef, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-65a47416"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("搜索")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("重置")
const _hoisted_3 = { key: 0 }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("编辑")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("保存修改")

import { ref, Ref, reactive, onBeforeMount, inject } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import dayjs from 'dayjs'
import OrderUploadList from './OrderUploadList.vue'
import tbMix from '@/global_mixin/tableMixin'
import { formatNumber, exportHandle } from '@/utils/index'
import Api from '@/http/modules/index'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const {
  'POST/order/delivered/query': fetchList,
  // 批量交付
  'POST/order/delivery/batch_delivery': batchDeliveryApi,
  // 订单交付_获取最新数据
  'GET/order/delivery/query_latest_data': query_latest_dataApi,
} = Api
const tableHeight = window.innerHeight
const viewsLoading: any= inject('viewsLoading')

let selectionRows = ref([])
const { 
  MI_tableData, fetchData, page, size, MI_total, MI_pageChange,
  MI_sizeChange, MI_identify, MI_params, MI_modifyForm, MI_height
} = new tbMix(fetchList)

const searchElement = ref()
const searchFormObject = reactive({
  orderNo: '',
  deliveredTime: [],
})

const searchHandle = () => {
  fetchData({
    query: {
      ...searchFormObject,
      deliveredTime: {
        from: searchFormObject.deliveredTime[0],
        to: searchFormObject.deliveredTime[1],
      }
    }
  })
}
searchHandle()


// 订单交付
const orderDeliveryEle = ref()
let deliverRows: any = ref([])
const isShowDeliver = ref<boolean>(false)


const deliveryHandle = () => {
  const isRight = orderDeliveryEle.value.deliveryOrderHandle()
  
  isRight.then((noList: number[]) => {
    if(noList.length === 0) return Promise.reject();
    MI_identify.value = true
    return batchDeliveryApi({ noList })
    
  }).then(() => {
    MI_identify.value = false
    searchHandle()
    ElMessage.success('修改成功')
    isShowDeliver.value = false
  }).catch(() => {
    MI_identify.value = false
  })
}

// 单独交付
const showDeliveryHandle = (row: any) => {
  if(row.rtAmount === 0 || row.amount === 0){
    ElMessageBox.confirm('订单金额或成本为0，是否继续交付', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(() => {
      deliverRows.value = [row]
      isShowDeliver.value = true
    }).catch(() => {})
    return
  }
  deliverRows.value = [row]
  isShowDeliver.value = true
}

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_collapse_item = _resolveComponent("el-collapse-item")!
  const _component_el_collapse = _resolveComponent("el-collapse")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_collapse, { class: "mb-10" }, {
      default: _withCtx(() => [
        _createVNode(_component_el_collapse_item, { title: "订单交付列表-搜索" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form, {
              "label-position": "left",
              model: _unref(searchFormObject),
              class: "searchBg",
              inline: true,
              ref_key: "searchElement",
              ref: searchElement,
              "label-width": "100"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, {
                  label: "订单号:",
                  prop: "orderNo"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      clearable: "",
                      maxlength: "200",
                      modelValue: _unref(searchFormObject).orderNo,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(searchFormObject).orderNo) = $event)),
                      placeholder: "请输入订单号",
                      class: "form-input"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "交付日期",
                  prop: "pm"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_date_picker, {
                      modelValue: _unref(searchFormObject).deliveredTime,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(searchFormObject).deliveredTime) = $event)),
                      type: "daterange",
                      "value-format": "YYYY-MM-DD",
                      "range-separator": "至",
                      "start-placeholder": "开始日期",
                      "end-placeholder": "结束日期"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      type: "primary",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (searchHandle()))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_1
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_button, {
                      onClick: _cache[3] || (_cache[3] = ($event: any) => {searchElement.value.resetFields(); _unref(searchFormObject).deliveredTime = []})
                    }, {
                      default: _withCtx(() => [
                        _hoisted_2
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["model"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
      border: "",
      data: _unref(MI_tableData),
      class: "mt-10",
      onSelectionChange: _cache[4] || (_cache[4] = (rows) => _isRef(selectionRows) //@ts-ignore
 ? selectionRows.value = rows : selectionRows = rows),
      "row-class-name": ({row}: any) => row.status === 'delivering' ? 'warning-row' : '',
      "max-height": _unref(MI_height) + 'px'
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          type: "selection",
          width: "50",
          fixed: ""
        }),
        _createVNode(_component_el_table_column, {
          label: "订单号",
          prop: "no",
          "show-overflow-tooltip": "",
          fixed: ""
        }),
        _createVNode(_component_el_table_column, {
          label: "订单名",
          prop: "name",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "客户名",
          prop: "customerUsername",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "联系人",
          prop: "customerContactor",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "PO号",
          prop: "poNo",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "PM",
          prop: "pm",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "AM",
          prop: "am",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "USD金额",
          prop: "baseCurrencyMoney",
          "show-overflow-tooltip": "",
          align: "right",
          formatter: _unref(formatNumber)
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "原币别",
          prop: "currency",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "原金额",
          prop: "amount",
          "show-overflow-tooltip": "",
          align: "right",
          formatter: _unref(formatNumber)
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "成本",
          prop: "rtAmount",
          "show-overflow-tooltip": "",
          align: "right",
          formatter: _unref(formatNumber)
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "创建日期",
          prop: "createTime",
          "show-overflow-tooltip": ""
        }, {
          default: _withCtx(({row}) => [
            _createTextVNode(_toDisplayString(row.createTime && _unref(dayjs)(row.createTime).format('YYYY-MM-DD')), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "交付日期",
          prop: "deliveryAt",
          "show-overflow-tooltip": ""
        }, {
          default: _withCtx(({row}) => [
            _createTextVNode(_toDisplayString(_unref(dayjs)(row.deliveryAt).format('YYYY-MM-DD')), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "首次开票时间",
          prop: "firstInvoicingTime",
          "show-overflow-tooltip": ""
        }, {
          default: _withCtx(({row}) => [
            _createTextVNode(_toDisplayString(row.firstInvoicingTime ? _unref(dayjs)(row.firstInvoicingTime).format('YYYY-MM-DD') : ''), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "勾销时间",
          prop: "verifyTime",
          "show-overflow-tooltip": ""
        }, {
          default: _withCtx(({row}) => [
            _createTextVNode(_toDisplayString(row.verifyTime ? _unref(dayjs)(row.verifyTime).format('YYYY-MM-DD') : ''), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "状态",
          prop: "status",
          "show-overflow-tooltip": ""
        }, {
          default: _withCtx(({row}) => [
            (row.status !== 'delivering')
              ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(row.status), 1))
              : (_openBlock(), _createBlock(_component_el_tooltip, {
                  key: 1,
                  effect: "dark",
                  content: "订单状态将在明天进行同步",
                  placement: "top"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", null, _toDisplayString(row.status), 1)
                  ]),
                  _: 2
                }, 1024))
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "交付文件",
          width: "100"
        }, {
          default: _withCtx(({ row }) => [
            _createVNode(_component_el_link, {
              type: "primary",
              onClick: ($event: any) => (showDeliveryHandle(row))
            }, {
              default: _withCtx(() => [
                _hoisted_4
              ]),
              _: 2
            }, 1032, ["onClick"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data", "row-class-name", "max-height"])), [
      [_directive_loading, _unref(MI_identify)]
    ]),
    _createVNode(_component_el_pagination, {
      background: "",
      small: "",
      class: "mt-10",
      total: _unref(MI_total),
      "page-size": _unref(size),
      currentPage: _unref(page),
      "onUpdate:currentPage": _cache[5] || (_cache[5] = ($event: any) => (_isRef(page) ? (page).value = $event : null)),
      "page-sizes": [30, 50, 100, 300],
      layout: "sizes, prev, pager, next, total, jumper",
      onCurrentChange: _unref(MI_pageChange),
      onSizeChange: _unref(MI_sizeChange)
    }, null, 8, ["total", "page-size", "currentPage", "onCurrentChange", "onSizeChange"]),
    _createVNode(_component_el_dialog, {
      modelValue: isShowDeliver.value,
      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((isShowDeliver).value = $event)),
      title: "订单编辑",
      fullscreen: ""
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          onClick: _cache[6] || (_cache[6] = ($event: any) => (isShowDeliver.value = false))
        }, {
          default: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[7] || (_cache[7] = ($event: any) => (deliveryHandle()))
        }, {
          default: _withCtx(() => [
            _hoisted_6
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        (isShowDeliver.value)
          ? (_openBlock(), _createBlock(OrderUploadList, {
              key: 0,
              "order-list": _unref(deliverRows),
              ref_key: "orderDeliveryEle",
              ref: orderDeliveryEle,
              isEdit: true
            }, null, 8, ["order-list"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})